// Actions
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ChestsResponse, CustomErrorPayload, IChestsStore, TChestResponse,
  TChestRewardHistory,
} from '../../../types';
import {
  getActiveChests, getChest, getChests, openChest,
} from './asyncActions';

// Types

const initialState: IChestsStore = {
  chestsHistory: null,
  chestsHistoryLoading: false,
  loading: true,
  error: null,
  chestRewards: {},
  chestsList: [],
  activeChest: null,
};

const chestsSlice = createSlice({
  name: 'chests',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(
        getActiveChests.fulfilled,
        (state, action: PayloadAction<ChestsResponse>) => {
          state.chestsHistory = action.payload;
          state.error = null;
          state.loading = false;
          state.chestsHistoryLoading = false;
        },
      )
      .addCase(
        getActiveChests.pending,
        (state) => {
          state.chestsHistoryLoading = true;
        },
      ).addCase(openChest.fulfilled, (state, action: PayloadAction<TChestRewardHistory>) => {
        if (action.payload.chest_history_id) {
          state.chestRewards[action.payload.chest_history_id] = action.payload.rewards;
        }
      }).addCase(getChests.fulfilled, (state, action: PayloadAction<TChestResponse[]>) => {
        state.loading = false;
        state.error = null;
        state.chestsList = action.payload;
      })
      .addCase(getChests.rejected, (state, action) => {
        const errorPayload = action.payload as CustomErrorPayload;
        state.error = errorPayload.response?.data?.message;
        state.loading = false;
      })
      .addCase(getChests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChest.fulfilled, (state, action: PayloadAction<TChestResponse>) => {
        state.loading = false;
        state.error = null;
        state.activeChest = action.payload;
      })
      .addCase(getChest.rejected, (state, action) => {
        const errorPayload = action.payload as CustomErrorPayload;
        state.error = errorPayload.response?.data?.message;
        state.loading = false;
      })
      .addCase(getChest.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
  },
  reducers: {
    setActiveChest(state, action: PayloadAction<TChestResponse | null>) {
      state.activeChest = action.payload;
    },
  },

});

export const { setActiveChest } = chestsSlice.actions;
export const ChestsReducer = chestsSlice.reducer;
